import { RefreshCcw } from "lucide-react";
import { useTranslation } from "../../i18n/hooks";

const SharedSuggestionLoading = () => {
  const { t } = useTranslation();
  
  return (
    <div className="text-sm text-gray-500 flex gap-3 items-center bg-red-50 p-2 rounded-md">
      <RefreshCcw className="w-4 h-4 text-orange-600 inline-block animate-spin" />
      <span className="text-orange-600">
        {t('sharedSuggestionLoading.thinking_configuration')}
      </span>
    </div>
  );
};

export default SharedSuggestionLoading;
